import React from "react";
import { altColor, secondaryTextColorOppositeShade } from "../../utils/constants";

export default function ChallengeReachedIcon({ color = altColor, color2 = secondaryTextColorOppositeShade }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 424.54 424.54">
      <defs>
        <radialGradient
          id="Unbenannter_Verlauf_2"
          cx="212.27"
          cy="657.14"
          r="202.62"
          gradientTransform="translate(0 -444.87)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color={color} />
          <stop offset="1" stop-color={color} />
        </radialGradient>
      </defs>
      <g id="Ebene_2" data-name="Ebene 2">
        <g id="Capa_1" data-name="Capa 1">
          <g id="Ebene_2-2" data-name="Ebene 2">
            <g id="Ebene_1-2" data-name="Ebene 1-2">
              <g id="Ebene_2-2-2" data-name="Ebene 2-2">
                <g id="Ebene_1-2-2" data-name="Ebene 1-2-2">
                  <circle
                    stroke={color}
                    strokeMiterlimit="10"
                    strokeWidth="19.31"
                    fill="url(#Unbenannter_Verlauf_2)"
                    cx="212.27"
                    cy="212.27"
                    r="202.62"
                  />
                </g>
              </g>
            </g>
          </g>
          <path
            fill={color2}
            d="M297.4,151.79l25.05-39.91a4.23,4.23,0,0,0-3.59-6.49H193.06v-9a21.54,21.54,0,1,0-28.93,0V287.75H138.79a10.62,10.62,0,0,0-10.62,10.61v15.33H118.06a10.63,10.63,0,0,0-10.62,10.62v13.17a10.63,10.63,0,0,0,10.62,10.61H247.23a10.63,10.63,0,0,0,10.62-10.61V324.31a10.63,10.63,0,0,0-10.62-10.62H237.12V298.36a10.62,10.62,0,0,0-10.62-10.61H193.06V198.19h64.29a4.24,4.24,0,0,0,0-8.48H193.06V113.86H311.2l-22.39,35.68a4.21,4.21,0,0,0,0,4.5l22.39,35.67H277.37a4.24,4.24,0,0,0,0,8.48h41.49a4.24,4.24,0,0,0,3.59-6.49ZM178.6,67.37a13.06,13.06,0,1,1-13.06,13.06A13.08,13.08,0,0,1,178.6,67.37Zm50.05,231v15.33h-40a4.24,4.24,0,0,0,0,8.47h58.61a2.19,2.19,0,0,1,2.15,2.15v13.17a2.18,2.18,0,0,1-2.15,2.14H118.06a2.17,2.17,0,0,1-2.14-2.14V324.31a2.18,2.18,0,0,1,2.14-2.15h50.52a4.24,4.24,0,1,0,0-8.47H136.64V298.36a2.17,2.17,0,0,1,2.15-2.14H226.5A2.17,2.17,0,0,1,228.65,298.36Zm-56-10.61V101.13a21.74,21.74,0,0,0,12,0V287.75Z"
          />
        </g>
      </g>
    </svg>
  );
}
